import React, { useState } from 'react';
import { Check, Star, AlertTriangle, ArrowRight, XCircle, MapPin, Menu, X } from 'lucide-react';
import { PopupNotification } from '../components/PopupNotification';
export function SalesPage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState<'base' | 'pro'>('pro');
  const checkoutUrl = 'Link de tu checkout'; // Placeholder as requested
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setIsMenuOpen(false);
    }
  };
  return <div className="min-h-screen bg-[#0f172a] font-sans text-gray-100 overflow-x-hidden selection:bg-yellow-500 selection:text-black" data-id="element-13">
      <PopupNotification data-id="element-14" />

      {/* NAVBAR */}
      <nav className="sticky top-0 z-50 bg-[#0f172a]/95 backdrop-blur-md border-b border-white/10 shadow-lg" data-id="element-15">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
          <div className="flex justify-between items-center h-16" data-id="element-17">
            <div className="flex-shrink-0 flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo(0, 0)} data-id="element-18">
              <span className="text-2xl" data-id="element-19">📘</span>
              <span className="font-bold text-white text-lg md:text-xl tracking-tight" data-id="element-20">
                Salud y Adolescencia 360
              </span>
            </div>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-8" data-id="element-21">
              <button onClick={() => scrollToSection('bonos')} className="text-gray-300 hover:text-white hover:text-[#eab308] transition-colors font-medium" data-id="element-22">
                Bonos
              </button>
              <button onClick={() => scrollToSection('testimonios')} className="text-gray-300 hover:text-white hover:text-[#eab308] transition-colors font-medium" data-id="element-23">
                Testimonios
              </button>
              <button onClick={() => scrollToSection('compra')} className="bg-[#dc2626] hover:bg-[#b91c1c] text-white px-6 py-2 rounded-full font-bold shadow-lg hover:shadow-red-500/30 transition-all transform hover:-translate-y-0.5" data-id="element-24">
                COMPRAR
              </button>
            </div>

            {/* Mobile Menu Button */}
            <div className="md:hidden" data-id="element-25">
              <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-300 hover:text-white p-2" data-id="element-26">
                {isMenuOpen ? <X size={24} data-id="element-27" /> : <Menu size={24} data-id="element-28" />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && <div className="md:hidden bg-[#1e293b] border-b border-white/10" data-id="element-29">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-30">
              <button onClick={() => scrollToSection('bonos')} className="block w-full text-left px-3 py-2 text-gray-300 hover:text-white hover:bg-white/5 rounded-md font-medium" data-id="element-31">
                Bonos
              </button>
              <button onClick={() => scrollToSection('testimonios')} className="block w-full text-left px-3 py-2 text-gray-300 hover:text-white hover:bg-white/5 rounded-md font-medium" data-id="element-32">
                Testimonios
              </button>
              <button onClick={() => scrollToSection('compra')} className="block w-full text-center mt-4 bg-[#dc2626] text-white px-3 py-3 rounded-md font-bold" data-id="element-33">
                COMPRAR AHORA
              </button>
            </div>
          </div>}
      </nav>

      {/* 2. HERO SECTION */}
      <section className="relative pt-12 pb-24 md:pt-20 md:pb-32 px-4 overflow-hidden section-diagonal-bottom" data-id="element-34">
        {/* Background Image with blur */}
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: `url('https://cdn.magicpatterns.com/uploads/gMntWMtb1kaGcSuvSAenGy/Gemini_Generated_Image_ga4iy4ga4iy4ga4i.png')`,
        filter: 'blur(4px)',
        transform: 'scale(1.05)'
      }} data-id="element-35"></div>
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-[#0a1628]/75" data-id="element-36"></div>

        <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-37">
          <div className="inline-flex items-center gap-2 bg-[#1e293b]/80 border border-[#eab308]/50 rounded-full px-4 py-1.5 mb-8 shadow-[0_0_15px_rgba(234,179,8,0.2)] backdrop-blur-sm" data-id="element-38">
            <Star size={14} className="text-[#eab308] fill-[#eab308]" data-id="element-39" />
            <span className="text-[#eab308] font-bold text-xs md:text-sm tracking-wide uppercase" data-id="element-40">
              EL SISTEMA #1 PARA DOCENTES DE SALUD
            </span>
            <Star size={14} className="text-[#eab308] fill-[#eab308]" data-id="element-41" />
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-black mb-10 leading-tight text-white drop-shadow-xl" data-id="element-42">
            SALUD Y ADOLESCENCIA 360:{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#eab308] to-[#facc15]" data-id="element-43">
              Herramientas Completas
            </span>
          </h1>

          {/* Mockup Image */}
          <div className="relative mx-auto max-w-2xl mb-8 cursor-pointer group" onClick={() => scrollToSection('compra')} data-id="element-44">
            <div className="absolute inset-0 bg-gradient-to-b from-[#16a34a]/30 to-[#1565c0]/30 blur-3xl opacity-60 group-hover:opacity-80 transition-opacity duration-500 rounded-full" data-id="element-45"></div>
            <img src="https://cdn.magicpatterns.com/uploads/5DMDqRg7UwQzQw52JscvSc/MOCKUP_SYA.png" alt="Salud y Adolescencia 360 Mockup" className="relative z-10 w-full drop-shadow-2xl transform group-hover:scale-[1.02] transition-transform duration-500" data-id="element-46" />
          </div>

          {/* New text block */}
          <div className="mb-10 max-w-3xl mx-auto" data-id="element-47">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-white mb-4 leading-tight drop-shadow-lg" data-id="element-48">
              ORGANIZA TU AÑO DE{' '}
              <span className="text-[#eab308]" data-id="element-49">Salud y adolescencia</span> SIN
              ESTRÉS
            </h2>
            <p className="text-base md:text-lg text-gray-200 leading-relaxed font-medium" data-id="element-50">
              Sistema completo de proyectos, experiencias y evaluaciones listas
              para usar.{' '}
              <span className="text-white font-bold" data-id="element-51">
                Todo tu año resuelto en un clic.
              </span>
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 mb-8" data-id="element-52">
            <button onClick={() => scrollToSection('compra')} className="w-full md:w-auto bg-[#16a34a] hover:bg-[#15803d] text-white text-lg md:text-xl font-bold py-4 px-8 rounded-full shadow-[0_0_20px_rgba(22,163,74,0.4)] hover:shadow-[0_0_30px_rgba(22,163,74,0.6)] active:scale-95 transition-all flex items-center justify-center gap-2 border border-white/10" data-id="element-53">
              👉 QUIERO ACCEDER AHORA
            </button>
            <button onClick={() => scrollToSection('bonos')} className="w-full md:w-auto bg-transparent hover:bg-white/5 text-white border-2 border-white/20 hover:border-white/40 text-lg md:text-xl font-bold py-3.5 px-8 rounded-full transition-all flex items-center justify-center gap-2" data-id="element-54">
              Ver Bonos <ArrowRight size={20} data-id="element-55" />
            </button>
          </div>

          <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-300 font-medium" data-id="element-56">
            <span className="flex items-center gap-1" data-id="element-57">
              <Check size={14} className="text-[#16a34a]" data-id="element-58" /> Acceso inmediato
            </span>
            <span className="hidden md:inline" data-id="element-59">·</span>
            <span className="flex items-center gap-1" data-id="element-60">
              <Check size={14} className="text-[#16a34a]" data-id="element-61" /> Descarga digital
            </span>
            <span className="hidden md:inline" data-id="element-62">·</span>
            <span className="flex items-center gap-1" data-id="element-63">
              <Check size={14} className="text-[#16a34a]" data-id="element-64" /> Garantía incluida
            </span>
          </div>
        </div>
      </section>

      {/* 2.1 SOCIAL PROOF — STATS + MINI TESTIMONIALS */}
      <section className="py-16 px-4 bg-[#0b1a2e] relative z-20" data-id="element-65">
        <div className="max-w-3xl mx-auto" data-id="element-66">
          {/* Stats grid */}
          <div className="grid grid-cols-2 gap-6 md:gap-8 mb-12" data-id="element-67">
            <div className="text-center" data-id="element-68">
              <p className="text-4xl md:text-5xl font-black text-[#eab308] leading-none mb-1" data-id="element-69">
                +500
              </p>
              <p className="text-gray-400 text-sm font-medium" data-id="element-70">
                docentes confían
              </p>
            </div>
            <div className="text-center" data-id="element-71">
              <p className="text-4xl md:text-5xl font-black text-[#eab308] leading-none mb-1" data-id="element-72">
                5
              </p>
              <p className="text-gray-400 text-sm font-medium" data-id="element-73">
                Tomos listos para usar
              </p>
            </div>
            <div className="text-center" data-id="element-74">
              <p className="text-4xl md:text-5xl font-black text-[#eab308] leading-none mb-1" data-id="element-75">
                4.9/5
              </p>
              <p className="text-gray-400 text-sm font-medium" data-id="element-76">
                calificación ⭐
              </p>
            </div>
            <div className="text-center" data-id="element-77">
              <p className="text-3xl md:text-4xl leading-none mb-1" data-id="element-78">🇦🇷</p>
              <p className="text-gray-400 text-sm font-medium" data-id="element-79">
                Todo el país — secundaria
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="w-16 h-0.5 bg-[#eab308]/30 mx-auto mb-10" data-id="element-80"></div>

          {/* Mini testimonials */}
          <div className="space-y-4" data-id="element-81">
            {[{
            initials: 'MG',
            quote: 'Organicé todo el año en una tarde',
            name: 'Mariela G.',
            info: 'Córdoba · Secundaria'
          }, {
            initials: 'LP',
            quote: 'Mis clases de secundaria por fin enganchan',
            name: 'Laura P.',
            info: 'Rosario · Secundaria'
          }, {
            initials: 'RM',
            quote: 'Nunca más improvisé una clase',
            name: 'Roberto M.',
            info: 'Buenos Aires · Secundaria'
          }].map((t, i) => <div key={i} className="bg-[#0f1f38] border border-white/5 rounded-xl px-5 py-4 flex items-center gap-4" data-id="element-82">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#16a34a] to-[#0f172a] flex items-center justify-center text-white text-xs font-bold shrink-0 border border-white/10" data-id="element-83">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-84">
                  <div className="flex items-center gap-0.5 text-[#eab308] mb-1" data-id="element-85">
                    {[1, 2, 3, 4, 5].map(s => <Star key={s} size={12} fill="currentColor" data-id="element-86" />)}
                  </div>
                  <p className="text-white font-bold text-sm leading-snug" data-id="element-87">
                    "{t.quote}"
                  </p>
                  <p className="text-gray-500 text-xs mt-0.5" data-id="element-88">
                    — {t.name}, {t.info}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 2.5 QUÉ INCLUYE SECTION */}
      <section className="py-16 px-4 bg-[#f0f9ff] relative z-30" data-id="element-89">
        <div className="max-w-5xl mx-auto" data-id="element-90">
          {/* Section header */}
          <div className="text-center mb-10" data-id="element-91">
            <span className="inline-block bg-[#16a34a]/15 text-[#15803d] border border-[#16a34a]/30 rounded-full px-4 py-1 text-xs font-bold uppercase tracking-widest mb-4" data-id="element-92">
              5 Tomos · 25 Clases · Nivel Secundaria
            </span>
            <h3 className="text-3xl md:text-4xl font-black text-gray-900 mb-3" data-id="element-93">
              ¿Qué incluye{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#15803d] to-[#16a34a]" data-id="element-94">
                Salud y Adolescencia 360?
              </span>
            </h3>
            <p className="text-gray-600 text-base max-w-2xl mx-auto" data-id="element-95">
              Todo tu año de Salud y Adolescencia organizado en 5 tomos con
              clases listas para aplicar.
            </p>
          </div>

          {/* Tomos grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-4xl mx-auto mb-8" data-id="element-96">
            {[{
            num: 1,
            title: 'Salud y Enfermedad',
            topics: 'Concepto de salud (OMS), determinantes sociales, sistema de salud argentino',
            classes: 5,
            color: 'from-[#1565c0] to-[#1d4ed8]'
          }, {
            num: 2,
            title: 'Adolescencia como Construcción Social',
            topics: 'Cambios físicos y psicológicos, identidad, cultura e influencia social',
            classes: 5,
            color: 'from-[#7c3aed] to-[#8b5cf6]'
          }, {
            num: 3,
            title: 'Salud Sexual y Reproductiva',
            topics: 'ESI, derechos, métodos anticonceptivos, ITS, embarazo adolescente',
            classes: 5,
            color: 'from-[#dc2626] to-[#ef4444]'
          }, {
            num: 4,
            title: 'Consumos Problemáticos',
            topics: 'Alcohol, tabaco, drogas, adicciones digitales, prevención',
            classes: 5,
            color: 'from-[#d97706] to-[#f59e0b]'
          }, {
            num: 5,
            title: 'Salud y Ciudadanía',
            topics: 'Salud como derecho, políticas públicas, hábitos saludables, participación juvenil',
            classes: 5,
            color: 'from-[#16a34a] to-[#22c55e]'
          }].map(tomo => <div key={tomo.num} className="bg-white rounded-xl border border-gray-200 p-4 shadow-sm flex gap-3" data-id="element-97">
                <div className={`w-10 h-10 rounded-lg bg-gradient-to-br ${tomo.color} flex items-center justify-center shrink-0 shadow-md`} data-id="element-98">
                  <span className="text-white text-sm font-black" data-id="element-99">
                    {tomo.num}
                  </span>
                </div>
                <div className="min-w-0" data-id="element-100">
                  <h5 className="font-bold text-gray-900 text-sm leading-tight mb-1" data-id="element-101">
                    {tomo.title}
                  </h5>
                  <p className="text-gray-500 text-xs leading-relaxed mb-1.5" data-id="element-102">
                    {tomo.topics}
                  </p>
                  <span className="text-[#16a34a] text-xs font-bold" data-id="element-103">
                    {tomo.classes} clases listas
                  </span>
                </div>
              </div>)}
          </div>

          {/* Summary + CTA */}
          <div className="max-w-4xl mx-auto bg-white rounded-xl border border-gray-200 shadow-sm p-5 flex flex-col sm:flex-row items-center justify-between gap-4 mb-10" data-id="element-104">
            <div className="flex items-center gap-3" data-id="element-105">
              <div className="w-9 h-9 bg-[#eab308] rounded-lg flex items-center justify-center shadow-md shrink-0" data-id="element-106">
                <span className="text-lg" data-id="element-107">📘</span>
              </div>
              <div data-id="element-108">
                <p className="font-bold text-gray-900 text-sm" data-id="element-109">
                  5 tomos · 25 clases · 100% editable
                </p>
                <p className="text-gray-400 text-xs" data-id="element-110">
                  Acceso inmediato · Descarga digital · Word y PDF
                </p>
              </div>
            </div>
            <button onClick={() => scrollToSection('compra')} className="bg-[#16a34a] hover:bg-[#15803d] text-white font-bold py-2.5 px-6 rounded-full shadow-[0_0_15px_rgba(22,163,74,0.3)] hover:shadow-[0_0_25px_rgba(22,163,74,0.5)] transition-all flex items-center gap-2 whitespace-nowrap text-sm" data-id="element-111">
              Quiero esto <ArrowRight size={16} data-id="element-112" />
            </button>
          </div>

          {/* FEATURES STRIP */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto" data-id="element-113">
            {[{
            icon: '⏱️',
            color: 'from-[#1d4ed8] to-[#2563eb]',
            title: 'Ahorro de Tiempo',
            desc: 'No pierdas horas planificando. Tenés todo listo para aplicar directamente en el aula.'
          }, {
            icon: '✏️',
            color: 'from-[#d97706] to-[#f59e0b]',
            title: '100% Editable',
            desc: 'Archivos en Word y PDF para que puedas adaptarlos a tu propio estilo y grupo.'
          }, {
            icon: '📐',
            color: 'from-[#dc2626] to-[#ef4444]',
            title: 'Diseño Curricular',
            desc: 'Contenidos alineados a los núcleos de aprendizaje prioritarios y al diseño curricular.'
          }, {
            icon: '🎯',
            color: 'from-[#7c3aed] to-[#8b5cf6]',
            title: 'Versatilidad Total',
            desc: 'Ideal para cualquier modalidad de secundaria, pública o privada, urbana o rural.'
          }].map((f, i) => <div key={i} className="flex flex-col items-center text-center gap-3" data-id="element-114">
                <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${f.color} flex items-center justify-center text-2xl shadow-lg`} data-id="element-115">
                  {f.icon}
                </div>
                <h5 className="font-bold text-gray-900 text-sm md:text-base" data-id="element-116">
                  {f.title}
                </h5>
                <p className="text-gray-500 text-xs md:text-sm leading-relaxed" data-id="element-117">
                  {f.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 3. BONUSES SECTION */}
      <section id="bonos" className="py-20 px-4 bg-[#f8fafc] section-diagonal-top section-diagonal-bottom relative z-20" data-id="element-118">
        <div className="max-w-4xl mx-auto" data-id="element-119">
          <h3 className="text-3xl md:text-4xl font-black text-center mb-12 text-gray-900" data-id="element-120">
            Con tu compra hoy recibís estos{' '}
            <span className="text-[#dc2626]" data-id="element-121">3 bonos sin costo adicional:</span>
          </h3>

          <div className="flex flex-col gap-5 mb-12" data-id="element-122">
            {/* Bonus 1 */}
            <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-md hover:shadow-lg hover:border-[#eab308]/50 transition-all duration-300 group flex flex-row" data-id="element-123">
              <div className="bg-gray-50 p-4 flex justify-center items-center w-32 md:w-44 shrink-0 relative overflow-hidden" data-id="element-124">
                <img src="https://cdn.magicpatterns.com/uploads/9ZA13v3N7yEemJJAn45BJs/BONO_1_SYA.png" alt="Bono 1" className="w-full object-contain transform group-hover:scale-105 transition-transform duration-500 drop-shadow-lg" data-id="element-125" />
              </div>
              <div className="p-5 flex flex-col justify-center" data-id="element-126">
                <span className="inline-block bg-[#eab308]/15 text-[#92400e] border border-[#eab308]/40 text-xs font-bold px-3 py-1 rounded-full mb-2 w-fit" data-id="element-127">
                  BONO 1 — GRATIS HOY
                </span>
                <h4 className="text-lg font-bold text-gray-900 mb-1" data-id="element-128">
                  Plan B Docente
                </h4>
                <p className="text-sm text-gray-500 leading-relaxed" data-id="element-129">
                  40 Actividades Salvavidas para Salud y Adolescencia.
                  Rompe-hielos dinámicos y consignas rápidas para cuando la
                  clase no arranca.
                </p>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-md hover:shadow-lg hover:border-[#eab308]/50 transition-all duration-300 group flex flex-row" data-id="element-130">
              <div className="bg-gray-50 p-4 flex justify-center items-center w-32 md:w-44 shrink-0 relative overflow-hidden" data-id="element-131">
                <img src="https://cdn.magicpatterns.com/uploads/rDV74eL5pfp8PLYpP1vubN/BONO_2_SYA.png" alt="Bono 2" className="w-full object-contain transform group-hover:scale-105 transition-transform duration-500 drop-shadow-lg" data-id="element-132" />
              </div>
              <div className="p-5 flex flex-col justify-center" data-id="element-133">
                <span className="inline-block bg-[#eab308]/15 text-[#92400e] border border-[#eab308]/40 text-xs font-bold px-3 py-1 rounded-full mb-2 w-fit" data-id="element-134">
                  BONO 2 — GRATIS HOY
                </span>
                <h4 className="text-lg font-bold text-gray-900 mb-1" data-id="element-135">
                  Pack Evaluar sin Estrés
                </h4>
                <p className="text-sm text-gray-500 leading-relaxed" data-id="element-136">
                  Evaluaciones trimestrales, trabajos prácticos y rúbricas de
                  corrección listas para usar.
                </p>
              </div>
            </div>

            {/* Bonus 3 */}
            <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-md hover:shadow-lg hover:border-[#eab308]/50 transition-all duration-300 group flex flex-row" data-id="element-137">
              <div className="bg-gray-50 p-4 flex justify-center items-center w-32 md:w-44 shrink-0 relative overflow-hidden" data-id="element-138">
                <img src="https://cdn.magicpatterns.com/uploads/chcQYJNJzekqcimPuGZ53p/BONO_3_SYA.png" alt="Bono 3" className="w-full object-contain transform group-hover:scale-105 transition-transform duration-500 drop-shadow-lg" data-id="element-139" />
              </div>
              <div className="p-5 flex flex-col justify-center" data-id="element-140">
                <span className="inline-block bg-[#eab308]/15 text-[#92400e] border border-[#eab308]/40 text-xs font-bold px-3 py-1 rounded-full mb-2 w-fit" data-id="element-141">
                  BONO 3 — GRATIS HOY
                </span>
                <h4 className="text-lg font-bold text-gray-900 mb-1" data-id="element-142">
                  Conversaciones que Sí Funcionan
                </h4>
                <p className="text-sm text-gray-500 leading-relaxed" data-id="element-143">
                  Guía de conversaciones diseñadas para abordar temas sensibles
                  con adolescentes reales.
                </p>
              </div>
            </div>
          </div>

          <p className="text-center text-xl font-medium text-gray-700" data-id="element-144">
            Valor total de los bonos:{' '}
            <span className="line-through text-gray-400 decoration-red-400/70 decoration-2" data-id="element-145">
              $29.970
            </span>{' '}
            — <span className="text-[#16a34a] font-bold" data-id="element-146">Hoy son GRATIS</span>
          </p>
        </div>
      </section>

      {/* 4. UNIFIED PURCHASE SECTION */}
      <section id="compra" className="py-16 px-4 bg-[#0a1628] relative section-diagonal-top z-10" data-id="element-147">
        <div className="max-w-xl mx-auto relative z-10" data-id="element-148">
          <h3 className="text-3xl md:text-4xl font-black text-white mb-8 drop-shadow-lg text-center" data-id="element-149">
            🚀 Elegí tu pack
          </h3>

          {/* Tier cards */}
          <div className="space-y-3 mb-6" data-id="element-150">
            {/* PRO tier — highlighted */}
            <button onClick={() => setSelectedPlan('pro')} className={`w-full text-left rounded-xl p-4 md:p-5 transition-all duration-200 border-2 ${selectedPlan === 'pro' ? 'border-[#eab308] bg-[#eab308]/5 shadow-[0_0_20px_rgba(234,179,8,0.15)]' : 'border-white/10 bg-[#0f1f38] hover:border-white/20'}`} data-id="element-151">
              <div className="flex items-start justify-between gap-4" data-id="element-152">
                <div className="flex items-start gap-3" data-id="element-153">
                  {/* Radio circle */}
                  <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedPlan === 'pro' ? 'border-[#eab308]' : 'border-gray-500'}`} data-id="element-154">
                    {selectedPlan === 'pro' && <div className="w-2.5 h-2.5 rounded-full bg-[#eab308]" data-id="element-155"></div>}
                  </div>
                  <div data-id="element-156">
                    <div className="flex items-center gap-2 flex-wrap mb-1" data-id="element-157">
                      <span className="text-lg font-black text-white" data-id="element-158">
                        🏆 PACK PRO
                      </span>
                      <span className="bg-[#eab308] text-black text-[10px] font-black px-2 py-0.5 rounded-full" data-id="element-159">
                        ⭐ MÁS ELEGIDO
                      </span>
                      <span className="bg-[#16a34a] text-white text-[10px] font-black px-2 py-0.5 rounded-full" data-id="element-160">
                        AHORRÁS $42.000
                      </span>
                    </div>
                    <p className="text-gray-400 text-sm" data-id="element-161">
                      Sistema completo + Kits de implementación + 3 bonos
                    </p>
                  </div>
                </div>
                <div className="text-right shrink-0" data-id="element-162">
                  <p className="text-gray-500 text-xs line-through" data-id="element-163">$69.990</p>
                  <p className="text-2xl md:text-3xl font-black text-[#eab308]" data-id="element-164">
                    $27.990
                  </p>
                </div>
              </div>
            </button>

            {/* BASE tier */}
            <button onClick={() => setSelectedPlan('base')} className={`w-full text-left rounded-xl p-4 md:p-5 transition-all duration-200 border-2 ${selectedPlan === 'base' ? 'border-[#eab308] bg-[#eab308]/5 shadow-[0_0_20px_rgba(234,179,8,0.15)]' : 'border-white/10 bg-[#0f1f38] hover:border-white/20'}`} data-id="element-165">
              <div className="flex items-start justify-between gap-4" data-id="element-166">
                <div className="flex items-start gap-3" data-id="element-167">
                  {/* Radio circle */}
                  <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedPlan === 'base' ? 'border-[#eab308]' : 'border-gray-500'}`} data-id="element-168">
                    {selectedPlan === 'base' && <div className="w-2.5 h-2.5 rounded-full bg-[#eab308]" data-id="element-169"></div>}
                  </div>
                  <div data-id="element-170">
                    <p className="text-lg font-black text-white mb-1" data-id="element-171">
                      📘 SALUD Y ADOLESCENCIA 360
                    </p>
                    <p className="text-gray-400 text-sm" data-id="element-172">
                      Sistema completo + 3 bonos GRATIS
                    </p>
                  </div>
                </div>
                <div className="text-right shrink-0" data-id="element-173">
                  <p className="text-gray-500 text-xs line-through" data-id="element-174">$49.990</p>
                  <p className="text-2xl md:text-3xl font-black text-white" data-id="element-175">
                    $19.990
                  </p>
                </div>
              </div>
            </button>
          </div>

          {/* CTA Button */}
          <a href={selectedPlan === 'pro' ? 'https://checkout.digitalmarket360.online/cart/42120502771767:1' : 'https://checkout.digitalmarket360.online/cart/42120499298359:1'} target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-to-r from-[#ca8a04] via-[#eab308] to-[#ca8a04] hover:from-[#b45309] hover:via-[#d97706] hover:to-[#b45309] text-white text-lg md:text-xl font-black py-5 px-4 rounded-xl shadow-[0_4px_15px_rgba(202,138,4,0.4)] hover:shadow-[0_4px_25px_rgba(202,138,4,0.6)] active:scale-[0.98] transition-all text-center tracking-wide mb-3" data-id="element-176">
            SÍ, QUIERO MI PACK →
          </a>

          <p className="text-center text-gray-500 text-sm italic mb-6" data-id="element-177">
            {selectedPlan === 'pro' ? 'La opción más elegida por docentes de secundaria' : 'Acceso inmediato al sistema completo'}
          </p>

          {/* PRO details — shown when PRO is selected */}
          {selectedPlan === 'pro' && <div className="bg-[#0f1f38] border border-[#eab308]/20 rounded-xl p-4 md:p-5 mb-6" data-id="element-178">
              <p className="text-[#eab308] font-black text-sm mb-3" data-id="element-179">
                🧩 ¿Qué incluye el Pack PRO?
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-180">
                {['✅ Salud y Adolescencia 360 completo', '🎁 Los 3 bonos GRATIS', '🔥 Dinámicas de Participación', '🔥 Manejo de Aula en Temas Sensibles', '🔥 Adaptaciones por Tipo de Curso'].map((item, i) => <p key={i} className="text-gray-300 text-xs md:text-sm" data-id="element-181">
                    {item}
                  </p>)}
              </div>
            </div>}

          {/* Trust badges */}
          <div className="bg-[#0f1f38] border border-white/5 rounded-xl py-3 px-4 flex items-center justify-center gap-4 md:gap-6 text-xs text-gray-400 flex-wrap" data-id="element-182">
            <span data-id="element-183">🔒 Pago seguro</span>
            <span data-id="element-184">⚡ Acceso en 5 min</span>
            <span data-id="element-185">🛡️ Garantía 7 días</span>
            <span data-id="element-186">💳 Mercado Pago</span>
          </div>
        </div>
      </section>

      {/* 5. TESTIMONIALS SECTION */}
      <section id="testimonios" className="py-20 px-4 bg-[#0d1f3c] section-diagonal-top relative z-0" data-id="element-187">
        <div className="max-w-6xl mx-auto" data-id="element-188">
          <h3 className="text-3xl md:text-4xl font-black text-center text-white mb-12" data-id="element-189">
            💬 Lo que dicen los docentes que{' '}
            <span className="text-[#eab308] underline decoration-4 decoration-[#eab308]/30" data-id="element-190">
              ya lo usan
            </span>
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-191">
            {[{
            name: 'Valeria M.',
            info: '38 años · Córdoba',
            text: 'Desde que tengo el sistema 360, entro al aula sabiendo exactamente qué hacer. Mis alumnos participan mucho más y llego los lunes sin ese nudo en el estómago.'
          }, {
            name: 'Romina G.',
            info: '44 años · Buenos Aires',
            text: 'Cuando empecé a usar este material me di cuenta de que el problema era el material anterior. Mis alumnos de 3° año ahora piden más clases de Salud. ¡Algo que nunca había pasado!'
          }, {
            name: 'Sebastián T.',
            info: '36 años · Rosario',
            text: 'El sistema 360 me dio la estructura y el lenguaje justo para abordar todo sin incomodidad. La planificación anual me ahorró horas y horas de trabajo.'
          }, {
            name: 'Marcela F.',
            info: '47 años · Mendoza',
            text: 'Este es el mejor material que tuve en mis manos para esta materia. Está pensado para el aula real. Mis colegas me preguntan qué cambié porque notan la diferencia.'
          }, {
            name: 'Laura P.',
            info: '33 años · La Plata',
            text: 'Dejé de planificar los domingos a la noche. Las clases fluyen solas y los chicos están enganchados. Si estás dudando, no lo pienses más. Vale cada peso.'
          }].map((t, i) => <div key={i} className="bg-[#0f172a] p-6 rounded-2xl shadow-lg border border-white/5 hover:border-[#0ea5e9]/30 transition-all duration-300 flex flex-col relative group" data-id="element-192">
                <div className="flex items-center gap-1 text-[#eab308] mb-4" data-id="element-193">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} size={14} fill="currentColor" data-id="element-194" />)}
                </div>
                <p className="text-gray-300 mb-5 flex-grow italic leading-relaxed text-sm" data-id="element-195">
                  "{t.text}"
                </p>
                <div className="flex items-center gap-3 mt-auto pt-4 border-t border-white/10" data-id="element-196">
                  <div className="w-10 h-10 bg-gradient-to-br from-[#1565c0] to-[#0a1628] rounded-full flex items-center justify-center text-white font-bold text-base shadow-inner border border-white/10 shrink-0" data-id="element-197">
                    {t.name.charAt(0)}
                  </div>
                  <div data-id="element-198">
                    <p className="font-bold text-white text-sm" data-id="element-199">{t.name}</p>
                    <p className="text-xs text-gray-500 mt-0.5" data-id="element-200">{t.info}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 6. FINAL URGENCY */}
      <section className="py-20 px-4 bg-gradient-to-b from-[#1565c0] to-[#0a1628] text-white text-center relative overflow-hidden" data-id="element-201">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-10" data-id="element-202"></div>

        <div className="relative z-10 max-w-3xl mx-auto" data-id="element-203">
          <h3 className="text-3xl md:text-5xl font-black mb-10 drop-shadow-md" data-id="element-204">
            Hacé clic y empezá hoy.
          </h3>
          <button onClick={() => scrollToSection('compra')} className="bg-white text-[#1565c0] hover:bg-gray-100 text-xl font-bold py-5 px-12 rounded-full shadow-2xl hover:shadow-white/20 transition-all flex items-center justify-center mx-auto gap-3 transform hover:-translate-y-1" data-id="element-205">
            ACCEDER AHORA <ArrowRight size={24} data-id="element-206" />
          </button>

          <footer className="mt-20 text-sm text-white/60 border-t border-white/20 pt-8" data-id="element-207">
            <p data-id="element-208">
              © {new Date().getFullYear()} Salud y Adolescencia 360. Todos los
              derechos reservados.
            </p>
            <p className="mt-2 text-xs" data-id="element-209">
              Este sitio no forma parte de Facebook o Facebook Inc.
            </p>
          </footer>
        </div>
      </section>
    </div>;
}